import {
  field,
  formatPatentPriorityDate,
  getFirstArrayValue,
  normalizePatentNumber,
} from "../../helpers";
import { googlePatentsTheme } from "../themes";

const googlePatentFamilySizeSummary = (value) => {
  return value >= 1 ? `${value} filings across jurisdictions` : "";
};

const MISSING_FAMILY_ID_VALUES = new Set([-1, "-1"]);

const shouldNAforMissingFamilyID = (value) => {
  return value === null || value === undefined || MISSING_FAMILY_ID_VALUES.has(value)
    ? "N/A"
    : value;
};

const googlePatentsConfig = {
  label: "Google Patents",
  theme: googlePatentsTheme,
  summary: {
    primary: field("Title", ["title"]),
    secondary: field("Publication", ["publication_number"], { kind: "id" }),
    columns: [
      field("Assignees", ["assignees"], {
        className: "hidden lg:block flex-[1.35] min-w-[10rem]",
        formatValue: getFirstArrayValue,
        missingValue: "Not assigned",
      }),
      field("Priority date", ["priority_date"], {
        className: "hidden md:block flex-[0.9] min-w-[7rem]",
        formatValue: formatPatentPriorityDate,
      }),
      field("Legal status", ["legal_status"], {
        className: "flex-[1] min-w-[7rem]",
        kind: "status",
      }),
      field("Family", ["family_id"], {
        className: "hidden xl:block flex-[0.7] min-w-[5rem]",
        kind: "accent",
        formatValue: shouldNAforMissingFamilyID,
      }),
    ],
  },
  detail: {
    meta: [
      field("Publication", ["publication_number"], { kind: "id" }),
      field("Application", ["application_number"], { kind: "accent" }),
      field("Legal status", ["legal_status"], { kind: "status" }),
    ],
    sections: [
      {
        title: "Ownership",
        fields: [
          field("Assignees", ["assignees"], {
            includeMissing: true,
            missingValue: "Not assigned",
          }),
          field("Inventors", ["inventors"], {
            includeMissing: true,
            missingValue: "Not listed",
          }),
        ],
      },
      {
        title: "Filling",
        fields: [
          field("Priority date", ["priority_date"], {
            formatValue: formatPatentPriorityDate,
          }),
          field("Filing date", ["filing_date"] , 
            {
               formatValue: formatPatentPriorityDate,
            }
          ),
          field("Publication date", ["publication_date"] , {
             formatValue: formatPatentPriorityDate,
          }),
          field("Jurisdiction", ["country_code"]),
          field("Kind code", ["kind_code"]),
        ],
      },
      {
        title: "Patent family",
        fields: [
          field("Family ID", ["family_id"], { formatValue: shouldNAforMissingFamilyID }),
          field("Family size", ["family_size"], { formatValue: googlePatentFamilySizeSummary }),
          field("Jurisdictions", ["jurisdictions" , "country_code"] , 
             {includeMissing: true,
              missingValue: "Not available",
               kind: "multi-badge",
            }
          ),
          field("Family publications", ["publication_numbers"]),
          field("CPC codes", ["cpc_codes"]),
          field("IPC codes", ["ipc_codes"]),
        ],
      },
      {
        title: "Abstract",
        fields: [field("Abstract", ["abstract"])],
      },
    ],
    links: [
      {
        label: "Google Patents",
        buildHref: (record, value) => {
          const patentNumber = normalizePatentNumber(value);
          return patentNumber
            ? `https://patents.google.com/patent/${patentNumber}`
            : "";
        },
        sources: ["publication_number"],
        valueLabel: "Open patent",
      },
      {
        label: "European Patent Office",
        buildHref: (record, value) => {
          const patentNumber = normalizePatentNumber(value);
          return patentNumber
            ? `https://worldwide.espacenet.com/patent/search?q=${patentNumber}`
            : "";
        },
        sources: ["publication_number"],
        valueLabel: "Open patent",
      },
    ],
  },
};

export default googlePatentsConfig;
